import { vuex as views } from "../views";
// create a new object and preserv original keys
export default [...views.plugins];
